import { HttpGetFunction } from "@lookiero/sty-psp-http";
import {
  IsCheckoutEnabledByCustomerIdProjection,
  IsCheckoutEnabledByCustomerIdView,
} from "../../../projection/checkout/viewIsCheckoutEnabledByCustomerId";

interface HttpIsCheckoutEnabledByCustomerIdView extends IsCheckoutEnabledByCustomerIdView {}

interface HttpIsCheckoutEnabledByCustomerIdViewFunctionArgs {
  readonly httpGet: HttpGetFunction;
}

interface HttpIsCheckoutEnabledByCustomerIdViewFunction {
  (args: HttpIsCheckoutEnabledByCustomerIdViewFunctionArgs): HttpIsCheckoutEnabledByCustomerIdView;
}

const httpIsCheckoutEnabledByCustomerIdView: HttpIsCheckoutEnabledByCustomerIdViewFunction =
  ({ httpGet }) =>
  async ({ customerId, signal }) =>
    await httpGet<IsCheckoutEnabledByCustomerIdProjection>({
      endpoint: `/is-new-checkout-enabled/${customerId}`,
      signal,
      result: {
        error: false,
        success: (response) => response,
      },
    });

export { httpIsCheckoutEnabledByCustomerIdView };
